module.exports = __webpack_public_path__ + "static/media/cornerpink.add76e46.png";